<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Attendance Menu" @click="$router.push('/myattendance')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <v-switch
                            v-model="viewAll"
                            label="View all"
                            color="primary"
                            hide-details
                        ></v-switch> 
                    </div>
                </v-toolbar>

                <!-- by cutoff -->
                <v-data-table
                    :headers="isMobile?header_mobile:header"
                    :items="ot_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync1"
                    v-show="!viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewCutoffDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td v-if="isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                    {{ props.item.cutOffStart | moment("MMM DD") }} - {{ props.item.cutOffEnd | moment("DD, YYYY") }}
                                </span>
                            </td>
                            <td v-if="!isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                            <td>{{ props.item.overtimeCount }}</td>
                        </tr>
                    </template>
                </v-data-table> 

                <!-- by calendar year -->
                <v-data-table
                    :headers="isMobile?headers_all_mobile:headers_all"
                    :items="overtime_all_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync2"
                    v-show="viewAll"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment("MMM DD") }}</span>
                                <span v-else>{{ props.item.transDate | moment("YYYY-MM-DD") }}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.hoursStr }}</td>
                            <td>{{ props.item.chargeableHours }}</td>
                            <td v-if="!isMobile">{{ props.item.startTime | moment("hh:mm a") }} - {{ props.item.endTime | moment("hh:mm a") }}</td>
                            <td>
                                <div v-if="isMobile">
                                    <span v-if="props.item.offsetOrPay==1">Time Off in Lieu</span>
                                    <span v-else>Paid Overtime</span>
                                </div>
                                <div v-else>
                                    <span v-if="props.item.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                                    <span v-else>Payroll (Paid Overtime)</span>
                                </div>
                            </td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

    </v-layout> 
</template>

<script>

import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, getViewAllSwitch, getCalendarYear, getSearchKeyword, updateCalendarYear, updateRowsPerPage, updateSort, updateViewAllSwitch, updateSearchKeyword } from '@/helpers/user-prefs'

export default {     
    name: 'Overtime',
    metaInfo: {
        title: 'Overtime',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {},
    data () {
        const routeName1 = `${this.$route.name}-table1`
        const routeName2 = `${this.$route.name}-table2`
        const savedSort1 = getSort(routeName1)
        const savedSort2 = getSort(routeName2)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync1: {
                rowsPerPage: getRowsPerPage(routeName1),
                sortBy: savedSort1.sortBy,
                descending: savedSort1.descending,
            },
            paginationSync2: {
                rowsPerPage: getRowsPerPage(routeName2),
                sortBy: savedSort2.sortBy,
                descending: savedSort2.descending,
            },
            viewAll: getViewAllSwitch(this.$route.name),
            selectedFiscalYear: getCalendarYear(this.$route.name),
            search: getSearchKeyword(this.$route.name),
            error: false,
            errorMessage: '',
            loading: false,
            header: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutOffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutOffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
                {text: 'Overtime Items',align: 'left',value: 'overtimeCount',  width: '10%', sortable:true},
            ],
            header_mobile: [
                {text: 'Cutoff Period',align: 'left',value: 'cutOffStart', width: '40%', sortable:true},
                {text: 'Status',align: 'left',value: 'cutOffStatus',  width: '30%', sortable:true},
                {text: 'Items',align: 'left',value: 'overtimeCount',  width: '30%', sortable:true},
            ],
            headers_all: [
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Hours',align: 'left',value: 'hoursStr', width:'5%',sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'5%',sortable:true},
                {text: 'Duration',align: 'left',value: 'startTime', width:'10%',sortable:true},
                {text: 'Charging Type',align: 'left',value: 'offsetOrPay', width:'10%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            headers_all_mobile: [
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Charge',align: 'left',value: 'chargeableHours', width:'10%',sortable:true},
                {text: 'Type',align: 'left',value: 'offsetOrPay', width:'40%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'40%',sortable:true},
            ],
            overtime_summary: [],
            overtime_all: [],            
            menu_status: false,
        }
    },
    methods: {
        isCurrentPeriod(data){
            return data.cutOffPeriodDesc == 'Current'
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            updateCalendarYear(this.$route.name, fiscalYear)
            this.initialize(false)
        },
        viewCutoffDetails(data) {
            this.$router.push(`overtime/summary/${data.cutOffId}`)
        },  
        viewDetails(data) {
            this.$router.push(`overtime/details/${data.overtimeId}`)
        }, 
        async getTimeOffSummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await overtimeApi.getSummary()     
                if (response && response.status == 200) {
                    this.overtime_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        async getAllTimeOff(show_loading) {
            try {
                this.loading = show_loading
                const response = await overtimeApi.getByFYByUser(this.selectedFiscalYear)     
                if (response && response.status == 200) {
                    this.overtime_all = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        initialize(show_loading) {
            if (this.viewAll) 
                this.getAllTimeOff(show_loading)
            else
                this.getTimeOffSummary(show_loading)
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Overtime',
            headerPageTitle: ''
        })
        
        this.initialize(true)
    },
    watch: {
        'paginationSync1.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-table1`, newVal);
        },
        'paginationSync2.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-table2`, newVal);
        },
        'paginationSync1.sortBy'(newVal) {
            updateSort(`${this.$route.name}-table1`, newVal, this.paginationSync1.descending)
        },
        'paginationSync2.sortBy'(newVal) {
            updateSort(`${this.$route.name}-table2`, newVal, this.paginationSync2.descending)
        },
        'paginationSync1.descending'(newVal) {
            updateSort(`${this.$route.name}-table1`, this.paginationSync1.sortBy, newVal)
        },
        'paginationSync2.descending'(newVal) {
            updateSort(`${this.$route.name}-table2`, this.paginationSync2.sortBy, newVal)
        },
        viewAll(newVal) {
            updateViewAllSwitch(this.$route.name, newVal)
            this.initialize(false)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        ot_summary_filtered() {
            var temp = this.overtime_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.cutOffStart.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        overtime_all_filtered() {
            var temp = this.overtime_all

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.transDate.includes(this.search))
                })
            }
            return temp 
        },        
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
    }
}
</script>